// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-tree-select{background:#f7f7f7!important;border-radius:3px!important;border:1px solid rgba(0,0,0,.38)!important;position:relative}.e-tree-select__title{font-size:1rem;color:#484b4d!important}.e-tree-select__title:before{content:\"*\";position:absolute;left:0;color:var(--v-primary-base);font-size:1.5rem}.e-tree-select__text{min-height:40px}", ""]);
// Exports
module.exports = exports;
